import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, FlaskConical, ShoppingBag, Users } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { Loader, LevelBadge } from "@/components/Common";
import { STATUS_LABEL } from "@/pages/Consultations";

export default function ProCases() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("aperti");
  useEffect(() => { api.get("/pro/cases").then(({ data }) => setItems(data)); }, []);
  if (!items) return <Loader />;
  const shown = items.filter((c) => (filter === "aperti" ? c.status !== "chiusa" : c.status === "chiusa"));

  return (
    <div className="space-y-5 px-5 py-6" data-testid="pro-cases-page">
      <div>
        <p className="eyebrow">Area riservata</p>
        <h1 className="font-serif text-4xl font-semibold text-[#0D2517]">Casi in consulenza</h1>
      </div>
      <Link to="/pro/utenti" className="flex items-center justify-between rounded-2xl bg-[#0D2517] p-4 text-[#F7F4EE]" data-testid="pro-users-link">
        <span className="flex items-center gap-2 text-sm"><Users size={16} className="text-[#C9A96E]" /> Utenti</span>
        <ChevronRight size={16} className="text-[#C9A96E]" />
      </Link>
      <Link to="/pro/pacchetti" className="flex items-center justify-between rounded-2xl bg-[#0D2517] p-4 text-[#F7F4EE]" data-testid="pro-packages-link">
        <span className="flex items-center gap-2 text-sm"><ShoppingBag size={16} className="text-[#C9A96E]" /> Pacchetti analisi</span>
        <ChevronRight size={16} className="text-[#C9A96E]" />
      </Link>
      <Link to="/pro/impieghi" className="flex items-center justify-between rounded-2xl bg-[#0D2517] p-4 text-[#F7F4EE]" data-testid="pro-uses-link">
        <span className="flex items-center gap-2 text-sm"><FlaskConical size={16} className="text-[#C9A96E]" /> Impieghi fitosanitari verificati</span>
        <ChevronRight size={16} className="text-[#C9A96E]" />
      </Link>
      <div className="grid grid-cols-2 gap-2">
        {["aperti", "chiusi"].map((f) => <button key={f} onClick={() => setFilter(f)} className={`chip ${filter === f ? "chip-on" : ""}`} data-testid={`pro-filter-${f}`}>{f === "aperti" ? "Aperti" : "Chiusi"}</button>)}
      </div>
      {shown.length === 0 && <p className="text-center text-sm text-[#5b6b60]" data-testid="pro-cases-empty">Nessun caso.</p>}
      {shown.map((c) => (
        <Link key={c.id} to={`/pro/casi/${c.id}`} className="block rounded-2xl border border-[#E2DCD0] bg-white p-4" data-testid={`pro-case-${c.id}`}>
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold">{c.user_name} · {fmtDate(c.created_at)}</p>
            <span className="rounded-full bg-[#C9A96E]/20 px-2 py-0.5 text-[10px] font-semibold text-[#7a5d2a]">{STATUS_LABEL[c.status]}</span>
          </div>
          <p className="mt-1 text-sm">{c.species?.common_name} <span className="botanical text-[#B39257]">{c.species?.botanical_name}</span></p>
          <div className="mt-2 flex items-center justify-between">
            <p className="text-xs text-[#5b6b60]">AI: {c.ai_main_cause?.name || "causa non determinata"}</p>
            {c.ai_confidence && <LevelBadge level={c.ai_confidence} label="AI" />}
          </div>
        </Link>
      ))}
    </div>
  );
}
